import {ContentState} from '../../store';
import {DEFAULT_TEXT_LIST, INPUT_TYPE} from '../constants';

export const initialParameterContentState: ContentState = {
  init: false,
  form: {
    parameter_value: '',
    parameter_value_options: DEFAULT_TEXT_LIST,
    parameter_is_list: false,
    parameter_type: INPUT_TYPE.TEXT,
  },
  isPreview: false,
  tmpForm: {},
}

// Functions
